// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PLAN_CHOOSE_CURRENT_QPXH,
} from './constants';

export function chooseCurrentQpxh(model) {
  return {
    type: PLAN_CHOOSE_CURRENT_QPXH,
    data:model
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_CHOOSE_CURRENT_QPXH:
      return {
        ...state,
        currentQpxh:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/chooseCurrentQpxh.js